import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import "./SalesDashboard.css";

/* ✅ API BASE URL */
const BASE_URL =
  process.env.REACT_APP_API_BASE_URL || "https://api.magnirauniverse.com";

export default function LeadsList() {
  const user = JSON.parse(localStorage.getItem("user"));
  const [leads, setLeads] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    if (!user?._id) return;

    axios
      .get(`${BASE_URL}/api/leads?salesManagerId=${user._id}`)
      .then((res) => setLeads(res.data || []))
      .catch((err) => console.error("Lead fetch error:", err));
  }, [user]);

  return (
    <div className="sf-list-page">
      {/* HEADER */}
      <div className="sf-list-header">
        <div style={{ display: "flex", alignItems: "center", gap: "15px" }}>
          {/* 🔙 Back Button */}
          <button
            onClick={() => navigate(-1)}
            style={{
              padding: "6px 14px",
              backgroundColor: "#0A5F59",
              color: "#fff",
              border: "none",
              borderRadius: "6px",
              cursor: "pointer",
              fontSize: "14px",
            }}
          >
            ⬅ Back
          </button>

          <div>
            <h2 style={{ margin: 0 }}>Active List</h2>
            <span className="sf-subtitle">All – Leads</span>
          </div>
        </div>

        <div className="sf-actions">
          <input className="sf-search" placeholder="Search this list..." />
          <button className="sf-btn primary">New</button>
          <button className="sf-btn">Import</button>
          <button className="sf-btn">Intelligence View</button>
        </div>
      </div>

      {/* TABLE */}
      <div className="sf-table-wrapper">
        <table className="sf-table">
          <thead>
            <tr>
              <th></th>
              <th>Name</th>
              <th>Title</th>
              <th>Company</th>
              <th>Email</th>
              <th>Phone</th>
              <th>Owner</th>
            </tr>
          </thead>

          <tbody>
            {leads.map((lead) => (
              <tr key={lead._id}>
                <td>
                  <input type="checkbox" />
                </td>

                {/* ✅ CLICK → NEW PAGE */}
                <td
                  className="sf-link"
                  style={{ cursor: "pointer", color: "#0176d3" }}
                  onClick={() => navigate(`/leads/${lead._id}`)}
                >
                  {lead.clientDetails?.ClientName || lead.leadName}
                </td>

                <td>{lead.title || "-"}</td>
                <td>{lead.company || "-"}</td>
                <td>{lead.clientDetails?.email || "-"}</td>
                <td>{lead.clientDetails?.phoneNumber || "-"}</td>
                <td>{lead.ownerName || "—"}</td>
              </tr>
            ))}

            {leads.length === 0 && (
              <tr>
                <td
                  colSpan="7"
                  style={{ textAlign: "center", padding: "20px" }}
                >
                  No leads found
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
